import AppRoute from "models/AppRoute"

const FairValueEvaluationRoute = new AppRoute({
    route: "/fair-value-evaluation",
    exact: true,
    navbar: true,
    authRequired: true,
})

export default FairValueEvaluationRoute
